export function ArrowSvg({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
    >
      <g clipPath="url(#clip0_2339_22523)">
        <path
          d="M2.50503 6.50503C2.23166 6.77839 2.23166 7.22161 2.50503 7.49497L6.9598 11.9497C7.23317 12.2231 7.67638 12.2231 7.94975 11.9497C8.22311 11.6764 8.22311 11.2332 7.94975 10.9598L3.98995 7L7.94975 3.0402C8.22311 2.76684 8.22311 2.32362 7.94975 2.05025C7.67638 1.77689 7.23317 1.77689 6.9598 2.05025L2.50503 6.50503ZM4 6.3H3V7.7H4V6.3Z"
          fill="#A2AFD0"
        />
      </g>
      <defs>
        <clipPath id="clip0_2339_22523">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
